import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const InternetIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 21" {...props}>
            <circle cx="10" cy="10.7021" r="8.25" stroke={props.htmlColor ?? '#21272E'} strokeWidth="1.5" fill="none" />
            <path
                d="M13.153 10.5024C13.1652 12.8817 12.1743 15.3861 9.9988 18.4364C7.82346 15.3862 6.83326 12.8819 6.84607 10.5025C6.85886 8.12789 7.87171 5.73995 10.0002 2.922C12.1286 5.73987 13.1408 8.12775 13.153 10.5024Z"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                fill="none"
            />
            <path
                d="M1.90002 8.00217C8.30589 8.45303 11.8532 8.45371 18.1 8.00217M1.86554 12.5954C8.172 12.9227 11.7791 12.9265 18.0655 12.5954"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
            />
        </SvgIcon>
    );
};
